// extracted by mini-css-extract-plugin
export default {"input":"styles__input___+Yq9O"};